// Property General Info Section - Name, External ID, Org ID
import React from 'react';
import { FormSection, FormField, NumericFormField } from '@/components/common/admin/form';

interface PropertyGeneralInfoSectionProps {
  marketingName: string;
  externalId: string;
  organizationId: string;
  nameError?: string;
  externalIdError?: string;
  organizationIdError?: string;
  onMarketingNameChange: (value: string) => void;
  onExternalIdChange: (value: string) => void;
  onOrganizationIdChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertyGeneralInfoSection: React.FC<PropertyGeneralInfoSectionProps> = ({
  marketingName,
  externalId,
  organizationId,
  nameError,
  externalIdError,
  organizationIdError,
  onMarketingNameChange,
  onExternalIdChange,
  onOrganizationIdChange,
  disabled,
}) => {
  return (
    <FormSection title="General Information">
      <FormField
        label="Name"
        value={marketingName}
        onChangeText={onMarketingNameChange}
        placeholder="Property name"
        error={nameError}
        required
        editable={!disabled}
      />

      <NumericFormField
        label="External ID"
        value={externalId}
        onChangeText={onExternalIdChange}
        placeholder="Entrata ID"
        error={externalIdError}
        required
        editable={!disabled}
      />

      <NumericFormField
        label="Organization ID"
        value={organizationId}
        onChangeText={onOrganizationIdChange}
        placeholder="Organization ID"
        error={organizationIdError}
        required
        editable={!disabled}
      />
    </FormSection>
  );
};

